import React from "react";
import { Label } from "reactstrap";
import PropTypes from "prop-types";

const ConversionInput = ({ handleChangeConversionFactor, missing_unit, normalized_unit }) => {
  return (
    <div>
      <div class="row col-sm-12">
        <div>
          <Label>{`1 ${missing_unit} = `}</Label>
        </div>
        <span
          className="input conversion-input"
          role="textbox"
          contentEditable
          id="first input"
          onInput={handleChangeConversionFactor}
        ></span>
        <div class="">
          <Label>{` ${normalized_unit}`}</Label>
        </div>
      </div>
      <div class="row col-sm-12">
        <div class="">
          <Label>{`1 ${normalized_unit} = `}</Label>
        </div>
        <span
          className="input conversion-input"
          role="textbox"
          contentEditable
          id="second input"
          onInput={handleChangeConversionFactor}
        ></span>
        <div class="">
          <Label>{` ${missing_unit}`}</Label>
        </div>
      </div>
    </div>
  );
};

ConversionInput.propTypes = {
  setSelectedItem: PropTypes.func,
  handleChangeConversionFactor: PropTypes.func,
  missing_unit: PropTypes.string,
  normalized_unit: PropTypes.string,
};

export default ConversionInput;
